<template>
  <div class="locale-select-wrapper">
    <v-select
      :value="selectedLocale"
      :items="localeOptions"
      item-text="label"
      item-value="id"
      dense
      hide-details
      outlined
      class="locale-select"
      @change="onLocaleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, getCurrentInstance } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const vm = getCurrentInstance()!.proxy as any;

const emit = defineEmits<{ (e: 'change', locale: string): void }>();

const localeOptions = [
  { id: 'cs', label: 'Čeština' },
  { id: 'sk', label: 'Slovenčina' },
  { id: 'hu', label: 'Magyar' },
  { id: 'en', label: 'English' },
  { id: 'uk', label: 'Українська' },
  { id: 'ru', label: 'Русский' }
];

const selectedLocale = ref(vm.$i18n.locale);

function onLocaleChange(locale: string) {
  selectedLocale.value = locale;
  emit('change', locale);
}
</script>

<style scoped>
.locale-select-wrapper {
  position: absolute;
  top: calc(env(safe-area-inset-top) + 16px);
  right: 16px;
}

.locale-select {
  width: 140px;
}
</style>
